/*!

=========================================================
* Now UI Dashboard React - v1.5.0
=========================================================

* Product Page: https://www.creative-tim.com/product/now-ui-dashboard-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/now-ui-dashboard-react/blob/main/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React, { useEffect, useState } from "react";

// reactstrap components
import {
  Card,
  CardHeader,
  CardBody,
  Row,
  Col,
  Spinner,
  Modal,
  ModalBody,
  ModalHeader,
  ModalFooter,
} from "reactstrap";
import { BASE_URL } from "../../utils/constants";
import { MDBDataTableV5 } from "mdbreact";
// core components
import PanelHeader from "../../components/PanelHeader/PanelHeader.js";
import Swal from "sweetalert2";
import axios from "axios";
import { useSelector } from "react-redux";
import IncidentModal from "./IncidentModal";

const Incidents = () => {
  const [p,setP]=useState(false);
  const permissions = useSelector((state) => state.permissions),
    [Modal, setModal] = useState(false),
    [Incidents, setIncidents] = useState([]);
    const [Grades, setGrades]=useState([]);

 const [IncidentId , setIncidentId] = useState(0);
  const   [intData, setIntData] = useState({
      columns: [
        {
          label: "#",
          field: "id",
        },
       
        {
          label: "Person in concern name",
          field: "name",
        },
        {
          label: "Description",
          field: "description",
        },
        {
          label: "Date",
          field: "incidentdate",
        },
       
        {
          label: "View",
          field: "view",
        },
      
      ],
      rows: [
        {
          id: <Spinner color="info" />,
          name: <Spinner color="info" />,
          description: <Spinner color="info" />,
          incidentdate: <Spinner color="info" />,
     
         
          view:<></>
         
        },
      ],
    });
    const handleViewModal=(id )=>{
        
    setIncidentId(id)
    setModal(true)
      }

      const updateIncidents = (incidents ) =>{
        setIntData((prevState) => {
          const newState = { ...prevState };
     
          let newRows = incidents?.map((i, key) => {
            return {
              ...i,
              view: (
                <>
                  <button
                    className="btn btn-info text-center fs-6 fw-bold py-1 px-3"
                    onClick={(e) => handleViewModal( i.id)}
                  >
                    View
                  </button>
                </>
              ),
            };
          });
          return { ...newState, rows: newRows };
        });
      }
  useEffect(async () => {
    Swal.showLoading();
    try {
      // waiting for Incidents api to get data>>
      let res = await axios.get(`${BASE_URL}/student/incidents/getincidents.php`);
      
      setIncidents(res.data.data.incidents);
      setGrades(res.data.data.grades);
      setIntData((prevState) => {
        const newState = { ...prevState };
        let ser = 1;
        // change .exams below to .homeworks and quiz to hmwork after backend finished
        let newRows = res.data.data.incidents?.map((i, key) => {
          return {
            ...i,
            incidentdate :i.incidentdate?.replace("T", " "),
            view: (
              <>
                <button
                  className="btn btn-info text-center fs-6 fw-bold py-1 px-3"
                  onClick={(e) => handleViewModal( i.id)}
                >
                  View
                </button>
              </>
            ),
          };
        });
        return { ...newState, rows: newRows };
      });
    } catch {
      Swal.fire("Something Went Wrong", "", "error");
    } finally {
      Swal.close();
    }
  }, [p]);





  return (
    <>

     <IncidentModal Modal = {Modal} setModal={setModal} IncidentId={IncidentId} setP={setP} p ={p} Grades = {Grades} updateIncidents= {updateIncidents} />
      <PanelHeader size="sm" />
      <div className="content">
        <Row>
          <Col md={12}>
            <Card className="w-100">
              <CardHeader>
                <h4 className="title">Incidents</h4>
        <button className="btn btn-primary" onClick ={()=>{
            setIncidentId("")
            
            setModal(true)}}>Report Incident</button>
              </CardHeader>
              <CardBody className="all-icons">
                <MDBDataTableV5
                  hover
                  responsive
                  borderless={false}
                  bordered
                  striped
                  entriesOptions={[5, 20, 25]}
                  entries={5}
                  pagesAmount={4}
                  data={intData}
                  fullPagination
                  searchTop
                  searchBottom={false}
                />
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>

     
    </>
  );
};

export default Incidents;
